{
	"cashflow": {
		"demonstrative": "Déclaration",
		"expensses": "Dépenses/Recettes",
		"extract": "Extract",
		"history": "Historique",
		"title": "Financier"
	},
	"competence": "Exécution",
	"dueDate": "Date d'échéance",
	"expenses": {
		"perAnything": "Payé à...",
		"perCategory": "Par Catégorie",
		"perCostCenter": "Par Centre de coûts",
		"perDay": "Par jour",
		"perDescripion": "Par Description",
		"perHistory": "Historique",
		"perType": "Par Type",
		"title": "DÉPENSES"
	},
	"receipts": {
		"perAnything": "Reçu de...",
		"perCategory": "Par Catégorie",
		"perCostCenter": "Par Centre de coûts",
		"perDay": "Par Jour",
		"perDescripion": "Par Description",
		"perHistory": "Historique",
		"perType": "Par Type",
		"title": "RECETTES"
	}
}
